import { Checkbox, Form } from "antd";
import React from "react";

const VoucherUseWith = ({ getFieldDecorator }) => {
  return (
    <>
    <Form.Item name="use_with_same_type" valuePropName="checked">
        {getFieldDecorator("use_with_same_type", {
          valuePropName: "checked",
          initialValue: false,
        })(<Checkbox>ใช้ร่วมกับบัตรกำนัลเดียวกัน</Checkbox>)}
      </Form.Item>
      <Form.Item name="use_with_product_type" valuePropName="checked">
        {getFieldDecorator("use_with_product_type", {
          valuePropName: "checked",
          initialValue: false,
        })(<Checkbox>ใช้ร่วมกับประเภทบัตรกำนัลส่วนลดเงินสดอื่นได้</Checkbox>)}
      </Form.Item>
      <Form.Item name="use_with_delivery_type" valuePropName="checked">
        {getFieldDecorator("use_with_delivery_type", {
          valuePropName: "checked",
          initialValue: false,
        })(<Checkbox>ใช้ร่วมกับประเภทบัตรกำนัลส่วนลดค่าจัดส่งอื่นได้</Checkbox>)}
      </Form.Item>
    </>
  );
};

export default VoucherUseWith;
